import React, { Component } from 'react';

class ScrollToTopButton extends Component {

    render () {
        return (
            <div>
            </div>
        )
    }
};

export default ScrollToTopButton;


// WEBPACK FOOTER //
// src/client/components/common/elements/ScrollToTopButton.js